/* global angular */

/**
* gc.lang Module
*/
angular
.module('gc.lang', ['pascalprecht.translate'])
.service('LanguageUtils', [
'$window',
'$translate',
'$rootScope',
'$log',
'GcUser',
'CommentService',
function($window, $translate, $rootScope, $log, GcUser, CommentService) {
  'use strict';

  function updateInternLanguage (lang) {
    if ($rootScope.lang === lang) return;

    document.documentElement.lang = lang;
    $rootScope.lang = lang;
    $translate.use(lang).then(function() {
      $rootScope.$broadcast('lang:change', lang);
    });
    
    var momentLocale = lang;
    if (momentLocale === 'zh') momentLocale = 'zh-cn';
    if (momentLocale === 'cz') momentLocale = 'cs';
    moment.locale(momentLocale);

    // rtl
    if (lang === 'he' || lang === 'fa' || lang === 'ar') {
      $rootScope.rtl = true;
      document.documentElement.dir = 'rtl';
    } else {
      $rootScope.rtl = false;
      document.documentElement.dir = 'ltr';
    }
  }

  function checkTranslationLoaded() {
    if ($translate.instant('all') !== 'all') {
      $('body').addClass('translations-loaded');
      return true;
    }
  }

  checkTranslationLoaded();
  var langInterval = setInterval(function() {
    if (checkTranslationLoaded()) {
      clearInterval(langInterval);
    }
  }, 100);

  window.gcSetLang = updateInternLanguage;

  /*-----------------------------------------------------------------------*
   * EXPOSED Functions :                                                   *
   *-----------------------------------------------------------------------*/

  this.init = function() {
    this.lang = this.getBrowserLanguage();
  };

  /**
   * Return a string representing the browser language on 2 characters
   * @return {String}
   */
  this.getBrowserLanguage = function(){
    var dataInit = { browser: '' };

    // get the browser language
    var found = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'].some(function (property) {
      var language = $window.navigator[property];
      if (language && language.length > 0) {
        $log.debug('browser language : ', language);
        this.browser = language;
        return true;
      }
      return false;
    }, dataInit);

    if (found) {
      var browserLanguage = dataInit.browser.slice(0, 2);
      return browserLanguage;
    }
  };

  this.updateUILanguage = function() {
    var gcLang;
    var user = GcUser.getUser();
    var languages = CommentService.website.languages;

    //$log.debug('lang user ?', user);
    //$log.debug('lang websites ?', languages);

    if (languages) {
      if (user && languages.indexOf(user.language) !== -1) {
        $log.debug('gcLang take user language : ', user.language);
        gcLang = user.language;
      }
      else if (languages.indexOf(this.lang)  !== -1 ) {
        $log.debug('gcLang take page language : ', this.lang);
        gcLang = this.lang;
      }
      else {
        $log.debug('gcLang take the default language : ', languages[0]);
        gcLang = languages[0];
      }

      updateInternLanguage(gcLang);
    }
  };

  /**
   * Return the language set in updateUILanguage
   * @returns {*|string}
   */
  this.getUserLanguage = function() {
    return $translate.use();
  };
}]);
